module.exports = __webpack_public_path__ + "img/Durability.99c4a892.svg";